import React from 'react';
import PropTypes from 'prop-types';
import { SignatureDeclineButtonWithRedux } from 'SignatureDeclineButton';
import { Link } from 'DesignSystem';

class RecipientBuilderIntroModalBody extends React.PureComponent {
  constructor(props) {
    super(props);

    this.onGotItClick = this.onGotItClick.bind(this);
  }

  onGotItClick() {
    window._track('Got It | Recipient Builder', 'Recipient Builder');
    this.props.close();
  }

  render() {
    return (
      <div className="self-serve-recipient-modal-body">
        <div className="modal-icon-wrapper">
          <img
            alt="pen writing on paper"
            className="modal-icon"
            src="images/self-serve-recipient-builder/modals/welcome-icon-2x.png"
          />
        </div>
        <div className="header">
          <p>Please fill out this document</p>
        </div>
        <div className="divider-wrapper">
          <div className="divider" />
        </div>
        <div className="recipient-builder-instructions-wrapper">
          <ul className="recipient-builder-instructions">
            <li>
              Click &quot;Finish and Send&quot; in the last section to return the completed form.
            </li>
            <li>Print or download a copy for your records after you send.</li>
            <li>Bookmark this page to save your progress and come back later.</li>
          </ul>
        </div>
        <div className="recipient-builder-terms-of-service-disclaimer">
          By clicking “OK, Got It”, you agree to be legally bound by this document and the&nbsp;
          <Link href="/terms">FormSwift Terms of Service.</Link>
        </div>
        <div className="close-modal-button-wrapper">
          <SignatureDeclineButtonWithRedux
            documentType={this.props.documentType}
            shareKey={this.props.shareKey}
            onDecline={this.props.onDecline}
            onCancel={this.props.onCancel}
            onConfirmDecline={this.props.close}
            useWhiteText={false}
          />
          <button
            className="close-modal-button"
            onClick={this.onGotItClick}
          >
            OK, Got it
          </button>
        </div>
      </div>
    );
  }
}

RecipientBuilderIntroModalBody.propTypes = {
  close: PropTypes.func.isRequired,
  documentType: PropTypes.string.isRequired,
  onDecline: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  shareKey: PropTypes.string.isRequired,
};


export default RecipientBuilderIntroModalBody;



// WEBPACK FOOTER //
// ./src-react/SelfServeModals/RecipientBuilderIntroModal/RecipientBuilderIntroModalBody.jsx